<template>
  <div style="background-color: #fff; padding: 16px; margin-bottom: 20px">
    <a-form-model
      size="small"
      layout="inline"
      :model="ajaxparams"
      @keyup.native.enter="$refs.myTable.search()"
    >
      <a-form-model-item label="商品名称">
        <a-input
          v-model="ajaxparams.goods_name_like"
          allow-clear
          placeholder="请输入商品名称"
          style="width: 200px"
        />
      </a-form-model-item>
      <a-form-model-item label="商品编号">
        <a-input
          v-model="ajaxparams.goods_number_like"
          allow-clear
          placeholder="请输入商品编号"
          style="width: 200px"
        />
      </a-form-model-item>
      <a-form-model-item>
        <a-button icon="search" type="primary" @click="$refs.myTable.search()"
          >搜索</a-button
        >
        <a-button @click="reset" style="margin-left: 8px">重置</a-button>
      </a-form-model-item>
    </a-form-model>

    <a-space>
      <a-button type="primary" class="mt10" @click="openAdd">添加</a-button>
    </a-space>

    <MyTable
      class="mt10"
      :apiUrl="packingGoods_goodsIndex"
      :params="ajaxparams"
      ref="myTable"
      :columns="columns"
      :isSelection="false"
    >
      <a-space slot="button" slot-scope="item, row, index">
        <a-button size="small" type="primary" @click="openEdit(row)"
          >编辑</a-button
        >
        <a-popconfirm
          title="确定删除该商品？"
          ok-text="确定"
          cancel-text="取消"
          @confirm="onDel(row)"
        >
          <a-button size="small" type="danger">删除</a-button>
        </a-popconfirm>
      </a-space>
      <template slot="unit_price" slot-scope="text">
        <span>{{ text }}</span>
      </template>
      <template slot="is_del" slot-scope="text">
        <span>{{ Number(text) === 1 ? "是" : "否" }}</span>
      </template>
    </MyTable>
    <a-modal
      :maskClosable="false"
      v-model="dialogVisible"
      :title="dialogTitle"
      :confirm-loading="submitLoading"
      @ok="onSubmit"
      @cancel="dialogVisible = false"
    >
      <a-form-model
        ref="formModel"
        size="small"
        :model="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="商品编号">
          <a-input v-model="form.goods_number" placeholder="请输入商品编号" />
        </a-form-model-item>
        <a-form-model-item label="商品名称">
          <a-input v-model="form.goods_name" placeholder="请输入商品名称" />
        </a-form-model-item>

        <a-form-model-item label="商品类型">
          <a-input v-model="form.classify" placeholder="请输入商品类型" />
        </a-form-model-item>
      <a-form-model-item label="计量单位">
          <a-input v-model="form.unit" placeholder="请输入计量单位" />
        </a-form-model-item>
        <a-form-model-item label="规格名称">
          <a-input v-model="form.spec_type" placeholder="请输入规格名称" />
        </a-form-model-item>
        <a-form-model-item label="每箱数量">
          <a-input
            type="number"
            v-model="form.num_per_box"
            placeholder="请输入每箱数量"
          />
        </a-form-model-item>
        <a-form-model-item label="单价">
          <a-input v-model="form.unit_price" placeholder="请输入单价" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import MyTable from "@/components/myTable.vue";
import {
  packingGoods_goodsIndex as goodsIndexApi,
  packingGoods_save,
  packingGoods_del,
} from "@/api/quality";
export default {
  name: "QualityGoodsIndex",
  components: { MyTable },
  data() {
    return {
      packingGoods_goodsIndex: goodsIndexApi,
      ajaxparams: {
        goods_name_like: "",
        goods_number_like: "",
      },
      dialogVisible: false,
      submitLoading: false,
      dialogTitle: "添加商品",
      form: {
        id: undefined,
        goods_name: "",
        goods_number: "",
        classify: "",
        unit: "",
        spec_type: "",
        num_per_box: undefined,
        unit_price: "",
      },
      columns: [
        {
          title: "操作",
          key: "operation",
          width: 220,
          fixed: "left",
          scopedSlots: { customRender: "button" },
        },
        {
          title: "商品编号",
          dataIndex: "goods_number",
          key: "goods_number",
          width: 160,
        },
        {
          title: "商品名称",
          dataIndex: "goods_name",
          key: "goods_name",
          width: 220,
          ellipsis: true,
        },
        {
          title: "商品类型",
          dataIndex: "classify",
          key: "classify",
          width: 120,
        },
        { title: "计量单位", dataIndex: "unit", key: "unit", width: 100 },
        {
          title: "规格名称",
          dataIndex: "spec_type",
          key: "spec_type",
          width: 120,
        },
        {
          title: "每箱数量",
          dataIndex: "num_per_box",
          key: "num_per_box",
          width: 120,
        },
        {
          title: "单价",
          dataIndex: "unit_price",
          key: "unit_price",
          width: 100,
          scopedSlots: { customRender: "unit_price" },
        },
        {
          title: "创建时间",
          dataIndex: "create_at",
          key: "create_at",
          width: 180,
        },
        {
          title: "更新时间",
          dataIndex: "update_at",
          key: "update_at",
          width: 180,
        },
      ],
    };
  },
  methods: {
    reset() {
      this.ajaxparams = { goods_name_like: "", goods_number_like: "" };
      this.$refs.myTable.search();
    },
    openAdd() {
      this.form = {
        id: undefined,
        goods_name: "",
        goods_number: "",
        classify: "",
        unit: "",
        spec_type: "",
        num_per_box: undefined,
        unit_price: "",
      };
      this.dialogTitle = "添加商品";
      this.dialogVisible = true;
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        goods_name: row.goods_name,
        goods_number: row.goods_number,
        classify: row.classify,
        unit: row.unit,
        spec_type: row.spec_type,
        num_per_box: row.num_per_box,
        unit_price: row.unit_price,
      };
      this.dialogTitle = "编辑商品";
      this.dialogVisible = true;
    },
    async onSubmit() {
      if (
        !this.form.goods_name ||
        !this.form.goods_number ||
        !this.form.classify ||
        !this.form.unit ||
        !this.form.spec_type ||
        !this.form.num_per_box ||
        !this.form.unit_price
      ) {
        this.$message.warning("请完整填写信息");
        return;
      }
      this.submitLoading = true;
      try {
        await packingGoods_save(this.form);
        this.$message.success("操作成功");
        this.submitLoading = false;
        this.dialogVisible = false;
        this.$refs.myTable.search();
      } catch (e) {
        this.submitLoading = false;
      }
    },
    async onDel(row) {
      try {
        await packingGoods_del({ id: row.id });
        this.$message.success("操作成功");
        this.$refs.myTable.search();
      } catch (e) {}
    },
  },
};
</script>

<style scoped>
.mt10 {
  margin-top: 10px;
}
</style>